export enum IconSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}
